import {
    LIST_UNITS,
    LIST_UNITS_SUCCESS,
    LIST_UNITS_ERROR,
    ADD_UNITS,
    SAVE_UNITS,
    SAVE_UNITS_SUCCESS,
    SAVE_UNITS_ERROR,
    EDIT_UNITS,
    UPDATE_UNITS,
    UPDATE_UNITS_SUCCESS,
    UPDATE_UNITS_ERROR,
    DELETE_UNITS,
    DELETE_UNITS_SUCCESS,
    DELETE_UNITS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    units: null,
    error: null,
    loading: false,
    unitSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_UNITS:
            return {
                ...state,
                loading: true
            }
        case LIST_UNITS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_UNITS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                units: action.payload
            }
        case SAVE_UNITS:
        case DELETE_UNITS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_UNITS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_UNITS_ERROR:
        case UPDATE_UNITS_ERROR:
        case DELETE_UNITS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_UNITS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                units: [...state.units, action.payload]
            }
        case ADD_UNITS:
            return {
                ...state,
                unitSelected: null,
                isEdit: false
            }
        case EDIT_UNITS:
            return {
                ...state,
                unitSelected: action.payload,
                isEdit: true
            }
        case UPDATE_UNITS_SUCCESS:
        case DELETE_UNITS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                units: state.units.map(unit => 
                    unit.id === action.payload.id ? unit = action.payload : unit
                ),
                unitSelected: null
            }
        // case DELETE_UNITS_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         units: state.units.filter( unit => unit.id !== action.payload)
        //     }
        default:
            return state;
    }
}